import { KYMW1311Component } from './kymw1311.component';

/**
 * 業態別企画書データ出力画面の値を管理するクラス
 *
 * @export KYMW1311Model
 * @class KYMW1311Model
 */
export class KYMW1311Model {

  kymw1311Component: KYMW1311Component;

  // 画面バインド用変数
  public orderCodeFrom: string = <string>'';                                    // 受注コード（開始）
  public orderCodeTo: string = <string>'';                                      // 受注コード（終了）
  public mediumType: string = <string>'';                                       // 媒体区分
  public pCode: string = <string>'';                                            // Ｐコード
  public dutiesWeeklyFlag: boolean = <boolean>false;                            // 業態区分（ウィークリー）
  public dutiesSpotFlag: boolean = <boolean>false;                              // 業態区分（スポット）

}
